import api from "./api";
import { Event } from "../Pages/ActivityHub/Components/ActivityAreaV2";

export const GetInternalMeetingsForActivityHub = async (
	opportunity_id: string,
	start_date: any,
	end_date: any,
): Promise<Event[]> => {
	return api
		.post("/get_customer_and_internal_meetings_for_activity_hub", {
			pod_user_id: Number(localStorage.getItem("podUserId")),
			opportunity_id,
			start_date,
			end_date,
		})
		.then(
			(res) =>
				res.data.customer_meetings_for_activity_hub.map((i: any) => ({
					...i,
					date: i.date.replaceAll("/", "-"),
				})) as Event[],
		);
};
